module.exports = __webpack_public_path__ + "787839a41988a0f1efb0384b03f8f112.png";